/**
 * Number format for AUD.
 */
export const AUDFormat = Intl.NumberFormat(undefined, {
  style: "currency",
  currency: "AUD",
});
